import { useState } from "react";
import { calculateExpression } from "../services/calculatorService";
import { formatMemoryAdd, formatMemorySubtract } from "../utils/calculatorUtils";

export const useCalculator = () => {
const [input, setInput] = useState(""), 
      [isResultDisplayed, setIsResultDisplayed] = useState(false), 
      [history, setHistory] = useState<string[]>([]), 
      [memory, setMemory] = useState<string[]>([]);  

  const handleButtonClick = (value: string) => {
    if (input === "Error") return setInput(value);
    if (isResultDisplayed && !isNaN(Number(value))) {
      setInput(value);
    } else {
      if (input === "0" && value === "00") return;
      // eslint-disable-next-line no-useless-escape
      const lastNumber = input.split(/[\+\-\*\/]/).pop();
      if (value === "." && lastNumber?.includes(".")) return;
      setInput((prev) => prev + value);
    }
    setIsResultDisplayed(false);
  };

  const handleCalculate = () => {
    try {
      const result = calculateExpression(input);
      if (!isNaN(result)) {
        setHistory((prev) => [...prev, `${input} = ${result}`]);
        setInput(result.toString());
        setIsResultDisplayed(true);
      } else setInput("Error");
    } catch {
      setInput("Error");
    }
  };
  
  const handleDelete = () => input === "Error" ? setInput("") : setInput((prev) => prev.slice(0, -1));
  const handleClear = () => setInput("");
  const handleMemorySave = () => {if (input) { const result = calculateExpression(input); setMemory((prev) => [...prev, `${input} = ${result}`]); }};
  const handleMemoryClear = () => setMemory([]);
  const handleMemoryRecall = () => memory.length && setInput(memory[memory.length - 1]);
  const handleMemoryAdd = () => { if (input && memory.length) { setMemory((prev) => [...prev.slice(0, -1), formatMemoryAdd(input, prev)]); } };
  const handleMemorySubtract = () => { if (input && memory.length) { setMemory((prev) => [...prev.slice(0, -1), formatMemorySubtract(input, prev)]); } };

  return {
    input,
    history,
    memory,
    handleButtonClick,
    handleDelete,
    handleClear,
    handleCalculate,
    handleMemorySave,
    handleMemoryClear,
    handleMemoryRecall,
    handleMemoryAdd,
    handleMemorySubtract,
    setHistory,
  };
};
